import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { PlacementsRoot } from '@/features/placements/Root';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';
import { SubjectEnumValues } from '@/types/common';

const progressSearchParams = z.object({
  subject: z
    .enum(SubjectEnumValues)
    .nullish()
    .transform((val) => (val === undefined ? null : val)),
  studentId: fallback(z.string(), '').default(''),
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
  {
    label: 'Placements',
    link: { to: '/admin/placements' },
  },
];

export const Route = createFileRoute('/admin/placements')({
  component: RouteComponent,
  validateSearch: zodValidator(progressSearchParams),
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AdminPageContent>
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
        <PlacementsRoot />
      </AdminPageContent>
    </>
  );
}
